<template>
    <div class="content-section" v-if="dataSet.total > 0">
        <div class="container">
            <div v-if="dataSet.data != null && dataSet.data.length > 0">
                <div class="row">
                    <div class="col-12">
                        <h3 class="title">{{ title }}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-6 directory--element__single" v-for="content in dataSet.data"
                        :key="content.id" :id="sectionItemId(content.id)" :data-search-item-id="content.id"
                        @click.capture="rememberLastVisited(content.id)">
                        <CardInstitution v-if="content.content_type_name == 'institution'" :content="content"
                            :style="'15px'" @click.native="rememberLastVisited(content.id)" />
                        <CardEvent v-else-if="content.content_type_name == 'angebot'" :content="content" :style="'15px'"
                            @click.native="rememberLastVisited(content.id)" />
                        <CardKultour v-else-if="content.content_type_name == 'kultour'" :collection="content"
                            @click.native="rememberLastVisited(content.id)" />
                        <CardAttractionSearch v-else-if="content.content_type_name == 'sehenswrdigkeit'"
                            :content="content" @click.native="rememberLastVisited(content.id)" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardEvent from '@/components/cards/CardEvent.vue';
import CardInstitution from '@/components/cards/CardInstitution.vue';
import CardKultour from '@/components/cards/CardKultour.vue';
import CardAttractionSearch from '@/components/cards/CardAttractionSearch.vue';
import { showLoader, hideLoader, isset } from '@/utils/helpers';
import { search } from '@/api/content';
import { buildFilterSignatureFromQuery, saveLastVisitedItem, loadLastVisitedItem } from '@/utils/helpers';

export default {
    name: 'Suche',
    components: {
        CardEvent,
        CardInstitution,
        CardKultour,
        CardAttractionSearch
    },
    props: {
        title: {
            type: String,
            required: true
        },
        searchWord: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loader: null,
            dataSet: {
                total: 0,
                data: null,
                meta: null,
                query: {
                    page: 1,
                    limit: 18,
                    keyword: '',
                    type: 'view',
                    view_status: 1,
                    resourceType: 'teaser',
                    selectedAppId: this.$appId,
                    selectedContentTypeId: null,
                    sort: {
                        prop: 'title',
                        order: 'ascending'
                    },
                },
            },
        }
    },
    computed: {

    },
    watch: {
        searchWord: {
            handler() {
                this.getContents();
            }
        }
    },
    emits: ['searchResults'],
    mounted() {
        switch (this.title) {
            case 'Anbieter':
                this.dataSet.query.selectedContentTypeId = this.$institutionId;
                this.dataSet.query.selectedAppId = this.$appId;
                break;
            case 'Veranstaltungen':
                this.dataSet.query.selectedContentTypeId = this.$offerId;
                this.dataSet.query.selectedAppId = this.$appId;
                break;
            case 'KulTouren':
                this.dataSet.query.selectedContentTypeId = this.$kultourId;
                delete this.dataSet.query.selectedAppId;
                break;
            case 'Sehenswürdigkeiten':
                this.dataSet.query.selectedContentTypeId = this.$attractionId;
                delete this.dataSet.query.selectedAppId;
                break;
        }
        this.getContents();
    },
    methods: {
        showLoader,
        hideLoader,
        async getContents() {
            this.loader = this.showLoader(this.loader);
            const { limit, page } = this.dataSet.query;
            this.dataSet.query.keyword = this.searchWord;
            const { data, meta } = await search(this.dataSet.query);
            this.dataSet.data = data;
            data.forEach((element, index) => {
                element['index'] = (page - 1) * limit + index + 1;
            });
            this.dataSet.meta = meta;
            this.dataSet.total = meta.total;
            this.loader = this.hideLoader(this.loader);
            this.$emit('searchResults', this.dataSet.total);
        },
        getCurrentFilterSignature() {
            const q = this.$route.query || {};
            const qp = {};
            if (q.keyword) qp.keyword = q.keyword;
            return buildFilterSignatureFromQuery(qp);
        },
        rememberLastVisited(id) {
            try {
                const signature = this.getCurrentFilterSignature();
                // disambiguate per section title so each box remembers its own item
                saveLastVisitedItem(this.$route.path + ':' + this.title, signature, id);
                // also set a central pointer for parent to know which section to target
                const centralKey = `lastVisited:${this.$route.path}:search:${signature}`;
                window.sessionStorage.setItem(centralKey, `${this.title}|${id}`);
            } catch (e) { /* no-op */ }
        },
        sectionItemId(id) {
            return `search-${this.title}-${id}`;
        },
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.content-section {
    margin-bottom: 40px;

    &:last-child {
        margin-bottom: 0;
    }
}

.title {
    font-size: 20px;
    margin-bottom: 20px;
}

.directory--element__single {
    margin-bottom: 30px;

    &:last-child {
        margin-bottom: 0;
    }
}
</style>
